import React, { useMemo, useRef } from 'react';
import { Button, Form, Radio, Spin } from 'antd';
import { PriceChannel } from '@/config';
import NoCouponData from '@/pages/guest/component/NoCouponData';
import ExchangeCodeModal, { IExchangeCodeRef } from '@/components/ExchangeCodeModal';
import PresentedCouponDrawer, { imperativeHandle } from '@/components/PresentedCouponDrawer';
import { renderIntlLabel } from '@/utils';
import CouponItem from '../CouponItem';
import styles from '../../index.module.scss';

const WangyuCouponList: React.FC<any> = ({
  wyuid,
  customerInfo,
  channelType,
  selectedId,
  currentList,
  wangyuCouponListLoading,
  onSelect,
  onGiveCouponClose,
  sortType,
  onSortRadioChange,
}) => {
  const exchangeRef = useRef<IExchangeCodeRef>();
  const giveAwayRef = useRef<imperativeHandle>();

  const walkinList = useMemo(() => {
    if (Array.isArray(currentList) && channelType !== PriceChannel.WALK_IN) {
      return currentList?.map((item) => ({
        ...item,
        walkinDisabled: true,
      }));
    }
    return currentList;
  }, [channelType, currentList]);

  const handleSelect = (couponNo) => {
    if (typeof onSelect === 'function') {
      onSelect(couponNo);
    }
  };

  const handleOpenExchangeCodeModal = () => {
    exchangeRef.current.openModal({
      record: { wyuid, ...customerInfo },
      onOk() {
        if (typeof onGiveCouponClose === 'function') {
          onGiveCouponClose();
        }
      },
    });
  };

  const handleOpenGiveCouponDrawer = () => {
    giveAwayRef.current.openDrawer({
      record: { wyuid, ...customerInfo },
      onOk() {
        if (typeof onGiveCouponClose === 'function') {
          onGiveCouponClose();
        }
      },
    });
  };

  const handleRadioChange = (e) => {
    if (onSortRadioChange) {
      onSortRadioChange(e.target.value);
    }
  };

  const renderTopMessage = () => {
    if (channelType === PriceChannel.WALK_IN) {
      if (Array.isArray(walkinList) && walkinList.length) {
        const allCouponNoList = walkinList?.map((item) => item.couponNo);
        return (
          <div style={{ marginBottom: '16px' }}>
            {renderIntlLabel('guest_coupon_label_current_avalible')}
            <span className={styles.number}>
              {walkinList?.filter((item) => !item.disabled)?.length}
            </span>
            {renderIntlLabel('guest_coupon_label_sheet')}，{' '}
            {renderIntlLabel('guest_coupon_label_up_to_selectable')}
            <span className={styles.number}>1</span>，{renderIntlLabel('guest_coupon_label_sheet')}
            {renderIntlLabel('guest_coupon_label_has_selected')}
            <span className={styles.number}>
              {selectedId?.length && selectedId.every((val) => allCouponNoList?.includes(val))
                ? selectedId?.length
                : 0}
            </span>
            {renderIntlLabel('guest_coupon_label_sheet')}
          </div>
        );
      }
      return null;
    }
    return (
      <div style={{ margin: '0 0 16px' }}>
        {renderIntlLabel('guest_coupon_label_avalible_wangyu_coupon_for_walkin')}
      </div>
    );
  };

  return (
    <>
      <Spin spinning={wangyuCouponListLoading}>
        <ExchangeCodeModal ref={exchangeRef} />
        <PresentedCouponDrawer ref={giveAwayRef} />

        <div
          style={{
            marginBottom: '16px',
            display: 'flex',
            justifyContent: walkinList?.length ? 'space-between' : 'flex-end',
          }}
        >
          {Array.isArray(walkinList) && walkinList.length ? (
            <Form.Item label={renderIntlLabel('guest_coupon_label_type_of_sort')}>
              <Radio.Group value={sortType} onChange={handleRadioChange}>
                <Radio.Button value={1}>
                  {renderIntlLabel('guest_coupon_label_via_indate')}
                </Radio.Button>
                <Radio.Button value={2}>
                  {renderIntlLabel('guest_coupon_label_via_money')}
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
          ) : null}
          <div>
            <Button
              type="primary"
              ghost
              onClick={handleOpenExchangeCodeModal}
              style={{ marginRight: '16px' }}
            >
              {renderIntlLabel('guest_action_use_conversion_code')}
            </Button>
            <Button type="primary" ghost onClick={handleOpenGiveCouponDrawer}>
              {renderIntlLabel('guest_action_store_coupon')}
            </Button>
          </div>
        </div>
        {renderTopMessage()}
        {Array.isArray(walkinList) && walkinList.length ? (
          <div className={styles.couponList}>
            {walkinList?.map((item) => (
              <CouponItem
                key={item.couponNo}
                // 非线下不可选，控制显示样式
                isCanSelect={!item.walkinDisabled}
                coupon={item}
                checked={!item.disabled && selectedId?.includes(item.couponNo)}
                disabled={item.disabled}
                onClick={handleSelect}
              />
            ))}
          </div>
        ) : (
          <NoCouponData />
        )}
      </Spin>
    </>
  );
};

export default WangyuCouponList;
